import { SVGProps } from 'react';

const FileCog = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M14 2v4a2 2 0 0 0 2 2h4M2.305 15.53l.923-.382m0-2.296-.924-.383M4.677 21.5a2 2 0 0 0 1.313.5H18a2 2 0 0 0 2-2V7l-5-5H6a2 2 0 0 0-2 2v2.5m.852 4.728-.383-.923m.383 6.467-.383.924m2.679-6.468.383-.923m-.001 7.391-.382-.924m1.624-3.92.923-.383m-.923 2.679.923.383M9 14a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default FileCog;
